import { newClient } from '../axios-client-factory'
import { requireNonNull } from '../../utils/coding-utils'


// 入会审批列表
export const getApplyList = function({query, pager, sorter}) {
  return newClient().post('/guild/join/apply/list', {
    page: pager.page,
    size: pager.limit,
    userId: requireNonNull(query.userId),
    userName: requireNonNull(query.userName),
    status: requireNonNull(query.status),
    applyStartTime: requireNonNull(query.applyStartTime),
    applyEndTime: requireNonNull(query.applyEndTime),
  })
}

/* 入会审批-拒绝/通过，
  operation  通过 1 拒绝2
*/
export const passApply = function (model) {
  return newClient().post('/guild/join/apply/passApply', model)
}

export const getGuildApprovalList = function({query, pager, sorter}) {
  return newClient().post('/guild/retreat/apply/list', {
    page: pager.page,
    size: pager.limit,
    userId: requireNonNull(query.userId),
    userName: requireNonNull(query.userName),
    status: requireNonNull(query.status),
    applyStartTime: requireNonNull(query.applyStartTime),
    applyEndTime: requireNonNull(query. applyEndTime),
  })
}

export const editQuildApproval = function (model) {
  return newClient().post('/guild/retreat/apply/operation', model)
}

// export const revenueLogInfo = function(userId) {
//   return newClient().get('/guild/invite-friend/income-detail/' + userId)
// }


// export const userRevenueInfo = function() {
//   return newClient().get('/guild/invite-friend/income-summary')
// }

// 获取微信，本次用不到
export const getWeChatDetail = function (model) {
  return newClient().post('/guild/new-assistant-feedback/records', model)
}

// 审核记录列表
export const getAnchorContractLog = function({query, pager, sorter}) {
  return newClient().post('/guild/retreat/apply/check/log', {
    page: pager.page,
    limit: 10000,
    signId: requireNonNull(query.signId),
  })
}

//转会列表
export const applyList = function (model) {
  return newClient().post('/guild/transfer/apply/list', model)
}
//通过操作
export const applyPass = function (model) {
  return newClient().post('/guild/transfer/apply/pass', model)
}
//拒绝操作
export const applyReject = function (model) {
  return newClient().post('/guild/transfer/apply/reject', model)
}



// WEBPACK FOOTER //
// ./src/api/anchor/management.js